const ENTITIES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }

// Escapes text for HTML built with template strings. Unlike the
// textContent/innerHTML trick it also escapes quotes, so the result is safe
// inside quoted attribute values as well as element text.
export function escapeHtml(value) {
  return String(value ?? "").replace(/[&<>"']/g, (char) => ENTITIES[char])
}
